module.exports = __webpack_public_path__ + "static/media/transfer.42c2b7ac.png";